module.exports = __webpack_public_path__ + "img/client-fortvernyi.92506096.jpeg";